import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "index";
import { LiveClassTemplate } from "types/LiveClassTemplate";


export type LiveClassTemplatesList = Record<number, LiveClassTemplate>;

const initialLiveClassTemplates: LiveClassTemplatesList = {}

export const elevateLiveClassTemplates = createSlice({
    name: 'elevateLiveClassTemplates',
    initialState: initialLiveClassTemplates,
    reducers: {
        updateLiveClassTemplates: (state, action: PayloadAction<LiveClassTemplatesList>) => {
            return (state = {
                ...state,
                ...action.payload
            })
        },
        resetLiveClassTemplates: (state) => {
            return (state = initialLiveClassTemplates)
        },
    },
})

export const { updateLiveClassTemplates, resetLiveClassTemplates } = elevateLiveClassTemplates.actions

export const liveClassTemplatesSelector = (state: RootState) => state.elevateCourses.liveclassTemplates